<template>
  <v-dialog
    v-if="offer && locations !== '/organization/profile'"
    v-model="dialog"
    class="offer-preview"
    width="80%"
    transition="dialog-bottom-transition"
  >
    <!-- Activator -->
    <template #activator={on,attrs}>
      <v-btn
        v-if="context === 'moderation'"
        class="moderation-card__btn"
        color="blue"
        outlined
        v-bind="attrs"
        v-on="on"
      >
        VER PUBLICACIÓN
      </v-btn>
      <v-btn
        v-else
        class="offer-preview__btn mr-md-6"
        color="info"
        button
        outlined
        large
        :disabled="loading"
        v-bind="attrs"
        v-on="on"
      >
        PREVISUALIZAR AVISO
      </v-btn>
    </template>

    <!-- Preview toolbar -->
    <v-toolbar
      class="offer-preview__toolbar rounded-t-xl"
      color="#5294E2"
      elevation="0"
      absolute
      dark
    >
      <v-toolbar-title>Oferta "{{ offer.title }}"</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn @click="onCloseClick" icon>
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <!-- Preview content -->
    <v-card>
      <v-col cols="12" class="ma-0 pa-0">
        <div>
          <div id="hero-preview-job">
            <v-parallax height="750" src="@/assets/images/back-single-oferta.webp">
            <v-container>
              <v-row justify="center">
                <v-col cols="11" sm="10" md="11" lg="9" class="text-left pa-0">
                  <v-row class="px-2" align="center">
                    <v-col cols="12" md="12" class="pa-0">
                      <v-avatar class="ma-0 float-left avatar-offer" >
                        <v-btn v-if="offer.alias === null || offer.alias === ''" small icon class="ma-0 pa-0 float-left txt-job" color="white" :to="{name: 'OrganizationHome', params:{slug: offer.organization.slug}}"><v-img :src="logoPath" > </v-img></v-btn>
                        <v-btn v-else small icon class="ma-0 pa-0 float-left txt-job" color="white" ><v-img :src="logoPath"> </v-img></v-btn>
                      </v-avatar>
                      <v-btn v-if="offer.alias === null || offer.alias === '' " small text class="float-left txt-job mt-10" color="white" :to="{name: 'OrganizationHome', params:{slug: offer.organization.slug}}">{{ offer.organization.name }}</v-btn>
                      <v-btn v-else small text class="float-left txt-job mt-10" color="white" to="/offers">{{offer.alias}} (USANDO ALIAS)</v-btn>
                    </v-col>
                  </v-row>
                  <v-row class="pa-0">
                    <v-col cols="12" sm="9" dm="9" class="px-3 py-1">
                      <h1>{{ offer.title }}</h1>
                    </v-col>
                    <v-col cols="3" sm="3" dm="3" class="d-none d-sm-block">
                      <p>&nbsp;</p>
                    </v-col>
                  </v-row>
                  <v-row class="pa-0">
                    <v-col cols="12">
                      <v-icon class="float-left mr-3 d-none d-sm-block" color="white">mdi-send</v-icon>
                      <p class="d-inline-block">Postulaciones: {{ getStartDate }} - {{ getEndDate }}</p>
                    </v-col>
                  </v-row>
                  <v-row class="pa-0">
                    <v-col cols="12" class="px-2 py-0">
                      <p class="d-block">Profesiones sugeridas: {{ professions }}</p>
                      <p class="d-block">Áreas de conocimiento: {{ areas }}</p>
                      <p class="d-block" v-if="offer && offer.experience && offer.experience.length > 0">Experiencia: {{offer.experience[0]}} y {{offer.experience[1] > 30 ? "30+" : offer.experience[1] }} Años</p>
                      <p class="d-block" v-if="!offer.salary.hidden">Renta: {{offer.salary.currency === "" ? "CLP" : offer.salary.currency}}{{formatter(offer.salary.range[0])}} a {{offer.salary.currency === "" ? "CLP" : offer.salary.currency }}{{formatter(offer.salary.range[1])}}</p>
                    </v-col>
                  </v-row>
                  <v-row class="px-0 pt-6">
                    <v-col cols="12" class="pa-0">
                      <div class="ma-1 pa-0 d-inline-block" v-for="(benefit, i) in offer.benefits" :key="i">
                        <img class="ma-0 pa-0 d-inline-block ico-benefits" :src="getBenefits(benefit)" />
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
            </v-parallax>
          </div>
          <div id="job-detail">
            <v-container>
              <v-row justify="center">
                <v-col cols="10" sm="3" md="3" lg="2" class="mx-md-0 mx-lg-10">
                  <v-card height="180">
                    <v-container>
                      <v-row align-content="center">
                        <v-col cols="12" class="py-1 text-center">
                          <v-icon>mdi-map-marker-outline</v-icon>
                            <h3>Lugar</h3>
                          <p>{{offer.city}}</p>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-col>
                <v-col cols="10" sm="3" md="3" lg="2" class="mx-md-0 mx-lg-10">
                  <v-card height="180">
                    <v-container>
                      <v-row align-content="center">
                        <v-col cols="12" class="py-1 text-center">
                          <v-icon>mdi-clock-time-four-outline</v-icon>
                          <h3>Jornada</h3>
                          <p>{{offer.workingDay}}</p>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-col>
                <v-col cols="10" sm="3" md="3" lg="2" class="mx-md-0 mx-lg-10">
                  <v-card height="180">
                    <v-container>
                      <v-row align-content="center">
                        <v-col cols="12" class="py-1 text-center">
                          <v-icon>mdi-office-building-marker-outline</v-icon>
                          <h3>Modalidad</h3>
                          <p>{{offer.workingMode}}</p>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-col>
                <v-col cols="10" sm="3" md="3" lg="2" class="mx-md-0 mx-lg-10">
                  <v-card height="180">
                    <v-container>
                      <v-row align-content="center">
                        <v-col cols="12" class="py-1 text-center">
                          <v-avatar class="icon-goals" tile v-for="goal in goalsToShow" :key="goal">
                            <v-tooltip top class="ma-0 my-0">
                              <template v-slot:activator="{ on, attrs }">
                                <img v-bind="attrs" v-on="on" class="" :src="require(`@/assets/images/goals/${goalsObj[goal-1].img}.webp`)"/>
                              </template>
                              <span>{{goalsObj[goal-1].tooltip}}</span>
                            </v-tooltip>
                          </v-avatar>
                          <h3>Propósitos</h3>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </div>

          <!-- Offer content -->
          <section class="content-job">
            <v-container>
              <v-row justify="center">
                <v-col cols="12" sm="11" md="11" lg="8">
                  <!-- Purpose -->
                  <v-row class="py-3" justify="center">
                    <v-col cols="11" sm="12" class="pa-0">
                      <img src="@/assets/images/ico-purpose.webp" class="ico-purpose d-none d-sm-block" />
                      <h2>Propósito del cargo</h2>
                    </v-col>
                    <v-col cols="10" sm="11" class="pa-0">
                      <div v-html="offer.purpose"></div>
                    </v-col>
                  </v-row>

                  <!-- Description -->
                  <v-row class="py-3" justify="center">
                    <v-col cols="11" sm="12" class="pa-0">
                      <img src="@/assets/images/ico-description.webp" class="ico-purpose d-none d-sm-block" />
                      <h2>Descripción</h2>
                    </v-col>
                    <v-col cols="10" sm="11" class="pa-0">
                      <div v-html="offer.description"></div>
                    </v-col>
                  </v-row>

                  <!-- Profile -->
                  <v-row class="py-3" justify="center">
                    <v-col cols="11" sm="12" class="pa-0">
                      <img src="@/assets/images/ico-profile.webp" class="ico-purpose d-none d-sm-block" />
                      <h2>Perfil buscado</h2>
                    </v-col>
                    <v-col cols="10" sm="11" class="pa-0">
                      <div v-html="offer.requirements"></div>
                    </v-col>
                  </v-row>

                  <!-- Desired -->
                  <v-row class="py-3" justify="center">
                    <v-col cols="11" sm="12" class="pa-0">
                      <img src="@/assets/images/ico-points.webp" class="ico-purpose d-none d-sm-block" />
                      <h2>Características que suman puntos</h2>
                    </v-col>
                    <v-col cols="10" sm="11" class="pa-0">
                      <div v-html="offer.optionals"></div>
                    </v-col>
                  </v-row>

                  <!-- Key dates -->
                  <v-row class="py-3" justify="center">
                    <v-col cols="11" sm="12" class="pa-0">
                      <img src="@/assets/images/ico-date.webp" class="ico-purpose d-none d-sm-block" />
                      <h2 class="title-date">Fecha estimada de incorporación al cargo</h2>
                    </v-col>
                    <v-col cols="10" sm="11" class="pa-0">
                      <div v-html="getStartToWorkDay"></div>
                    </v-col>
                  </v-row>

                  <!-- Questions -->
                  <v-row class="py-3" justify="center">
                    <v-col cols="11" sm="12" class="pa-0">
                      <img src="@/assets/images/ico-feedback.webp" class="ico-purpose d-none d-sm-block" />
                      <h2>Preguntas</h2>
                    </v-col>
                    <v-col cols="10" sm="11" class="pa-0">
                      <ul>
                        <li v-for="(question, index) in activeQuestions" :key="index">
                          <div v-html="question.label"></div>
                        </li>
                      </ul>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <!-- Org banner -->
              <v-row justify="center">
                <v-col cols="12" sm="10" md="10" lg="8">
                  <v-card class="mt-12 mb-3 card-offer-company" v-if="offer.alias === null && offer.alias === ''" :to="{name: 'OrganizationHome', params:{slug: offer.organization.slug}}">
                    <v-row justify="center">
                      <v-col cols="2" sm="2" md="2" class="py-0 d-none d-sm-block">
                        <v-list-item-avatar size="90" color="white" class="ma-0 pa-0">
                          <v-img style="background-color: #FFFFF !important;" contain max-width="65" max-height="90" :src="logoPath"></v-img>
                        </v-list-item-avatar>
                      </v-col>
                      <v-col cols="12" sm="10" md="10" class="px-3 py-0">
                        <v-list-item-content class="d-flex justify-start">
                          <v-list-item-title class="title-card d-flex">
                            {{ offer.organization.name }}
                          </v-list-item-title>
                          <v-list-item-subtitle class="sub-title-card d-flex">
                            <v-btn small text class="ma-0 pa-0" color="white" :to="{name: 'OrganizationHome', params:{slug: offer.organization.slug}}">Ver perfil de la empresa</v-btn>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </section>
        </div>
      </v-col>
    </v-card>
  </v-dialog>
</template>

<script>
import { currentImg } from "@/libs/mixins";

export default {
    name: "OfferPreview",

    props: ["context", "loading", "offer"],

    mixins: [currentImg],

    data() {
        return {
            dialog: false,
            goalsObj: [
                { tooltip: "Fin a la Pobreza", img: "goal-01" },
                { tooltip: "Hambre cero", img: "goal-02" },
                { tooltip: "Salud y bienestar", img: "goal-03" },
                { tooltip: "Educación de calidad", img: "goal-04" },
                { tooltip: "Igualdad de género", img: "goal-05" },
                { tooltip: "Agua limpia y saneamiento", img: "goal-06" },
                { tooltip: "Energía asequible y no contaminante", img: "goal-07" },
                { tooltip: "Trabajo decente y crecimiento económico", img: "goal-08" },
                { tooltip: "Industria, innovación e infraestructura", img: "goal-09" },
                { tooltip: "Reducción de las desigualdades", img: "goal-10" },
                { tooltip: "Ciudades y comunidades sostenibles", img: "goal-11" },
                { tooltip: "Producción y consumo responsables", img: "goal-12" },
                { tooltip: "Acción por el clima", img: "goal-13" },
                { tooltip: "Vida submarina", img: "goal-14" },
                { tooltip: "Vida de ecosistemas terrestres", img: "goal-15" },
                { tooltip: "Paz, justicia e instituciones sólidas", img: "goal-16" },
                { tooltip: "Alianzas para lograr objetivos", img: "goal-17" }
            ],
            locations: "",
            goalsToShow: [],
            title: "",
        };
    },
    created() {
        this.locations = location.pathname;
        this.title = this.offer ? this.offer.title : "";
        this.goalsToShow = this.offer ? this.offer.organization.goals.slice(0, 4) : [];
    },
    computed: {
        activeQuestions() {
            return this.offer.questions.filter(question => !question.removed);
        },
        areas() {
            return this.offer.areas.join(", ");
        },
        getEndDate() {
            if (this.offer.validity.end && this.offer.validity.end.includes("-")) {
                const [year, month, day] = this.offer.validity.end.split("-");
                return `${day}/${month}/${year}`;
            }
            return this.offer.validity.end || "";
        },
        getStartDate() {
            let date = new Date();
            return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
        },
        getStartToWorkDay() {
            if (this.offer.startAt && this.offer.startAt.includes("-")) {
                const [year, month, day] = this.offer.startAt.split("-");
                return `${day}/${month}/${year}`;
            }
            return this.offer.startAt || "";
        },
        goals() {
            let goals = [];
            // TODO Cambiar PATH IMG
            this.offer.organization.goals.forEach(goalId => {
                goals.push("@/assets/images/goals/" + pad(goalId, 2) + ".webp");
            });
            return goals;
        },
        logoPath() {
            let path = require("@/assets/images/avatar-default-icon.webp");
            if (this.offer.alias === null || this.offer.alias === "" && this.offer.organization.media.logo != "" && this.offer.organization.media.logo) {
                path = process.env.VUE_APP_ROOT_ASSETS + process.env.VUE_APP_ASSETS_LOGO_PATH + this.offer.organization.media.logo;
            }
            return path;
        },
        professions() {
            return this.offer.professions.join(", ");
        },
    },
    methods: {
        formatter(value) {
            const formatter = new Intl.NumberFormat("es-CL", {
                style: "currency",
                currency: this.offer.salary.currency === "" ? "CLP" : this.offer.salary.currency,
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            });
            return formatter.format(value);
        },
        onCloseClick() {
            this.dialog = false;
        },
    }
};
</script>

<style scoped>
.bottom-line {
    border-bottom-style: solid ;
}
#hero-preview-job {
    background:#3BADFF;
}
#hero-preview-job .txt-job{
    color: #FFF;
    font-size: 16px;
    font-family:"Circular";
    letter-spacing: normal;
    margin: 0;
    height: auto;
    text-decoration: underline;
}
#hero-preview-job .txt-job::before{
    opacity: 0;
}
#hero-preview-job h1{
    color: #FFF;
    font-size: 35px;
    line-height: 40px;
    font-family:"CircularBlack";
    margin:0;
}
#hero-preview-job p{
    color: #fff;
    font-size: 18px;
    margin: 0;
    font-family: "CircularLight";
}
#hero-preview-job .txt-postulate{
    color: #fff;
    font-size: 18px;
    margin: 0;
    font-family: "CircularLight";
}
#hero-preview-job .v-image{
    width: 80px !important;
    height: 80px !important;
    display: inline-block;
    margin: 0 !important;
}
#hero-preview-job .avatar-offer{
    width: 80px !important;
    height: 80px !important;
    display: inline-flex;
    margin: 0 !important;
}
#hero-preview-job button{
    margin: 10px 0 !important;
    font-size: 16px !important;
    color: #3BADFF !important;
    text-decoration: none;
    background: #FFF;
    border: 1px solid #3BADFF;
    border-radius: 5px;
    font-family: "CircularBlack";
}
#hero-preview-job button{
    color: #3BADFF !important;
    width:100%;
}
#hero-preview-job .avatar-profile{
    width: 60px;
    margin-right: 10px;
}
#hero-preview-job .v-parallax{
    height: 480px !important;
    padding:0;
    /* margin:80px 0 0; */
}
#hero-preview-job .ico-benefits{
    width: 40px !important;
    height: 40px !important;
    display: block;
}
#hero-preview-job .v-parallax__image-container img{
    top: -40%;
}
#hero-preview-job button{
    width:50%;
}
#hero-preview-job h1{
    font-size: 50px;
    line-height: 50px;
}
@media only screen and (min-width: 568px) {
    #hero-preview-job .v-parallax{
        height: 520px !important;
    }
    #hero-preview-job button{
        width:50%;
    }
    #hero-preview-job h1{
        font-size: 50px;
        line-height: 50px;
    }
    #hero-preview-job .v-parallax{
        height: 640px !important;
    }
}
@media only screen and (min-width: 992px) {
    #hero-preview-job .v-parallax{
        height: 640px !important;
    }
    #hero-preview-job button{
        width:30%;
    }
}
@media only screen and (min-width: 1023px) {
    #hero-preview-job .v-parallax{
        height: 500px !important;
    }
}
</style>
